import {
    SET_SERVER_STATUS,
    SET_SERVER_STATUS_LOADING,
    ServerStatusState,
    ServerStatusActionTypes,
} from './types';


const initialState : ServerStatusState = {
    status: '',
    msg: '',
    loading: false,
}

export function serverStatusReducer(
    state = initialState,
    action : ServerStatusActionTypes,
): ServerStatusState {
    switch(action.type) {
        case SET_SERVER_STATUS:
            return { ...state, status: action.payload.status, msg: action.payload.msg};
        case SET_SERVER_STATUS_LOADING: 
            return { ...state, loading: action.payload };
        default: 
            return {...state};
    }
}